import Highlights from '../src/Highlights/index.tsx';
export default Highlights;
